import React from 'react';
import PropTypes from 'prop-types';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  TextField,
  Button,
} from '@mui/material';

const InventoryForm = ({
  open,
  mode,
  formData,
  formErrors,
  onClose,
  onSubmit,
  onInputChange,
}) => {
  const getDialogTitle = () => {
    switch (mode) {
      case 'add':
        return 'Add New Inventory Item';
      case 'edit':
        return 'Edit Inventory Item';
      case 'view':
        return 'Inventory Item Details';
      default:
        return 'Inventory Item';
    }
  };

  const isViewMode = mode === 'view';

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{getDialogTitle()}</DialogTitle>
      <DialogContent>
        <Grid container spacing={2} sx={{ mt: 1 }}>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Item Name"
              value={formData.name}
              onChange={(e) => onInputChange('name', e.target.value)}
              disabled={isViewMode}
              error={!!formErrors.name}
              helperText={formErrors.name}
              required
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Serial Number"
              value={formData.serial_number}
              onChange={(e) => onInputChange('serial_number', e.target.value)}
              disabled={isViewMode}
              error={!!formErrors.serial_number}
              helperText={formErrors.serial_number || "Optional serial number or identifier"}
              placeholder="Enter serial number (optional)"
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Description"
              value={formData.description}
              onChange={(e) => onInputChange('description', e.target.value)}
              disabled={isViewMode}
              error={!!formErrors.description}
              helperText={formErrors.description}
              multiline
              rows={3}
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              fullWidth
              label="Quantity"
              type="number"
              value={formData.quantity}
              onChange={(e) => onInputChange('quantity', e.target.value)}
              disabled={isViewMode}
              error={!!formErrors.quantity}
              helperText={formErrors.quantity}
              required
              inputProps={{ min: 0 }}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        {!isViewMode && (
          <Button onClick={onSubmit} variant="contained">
            {mode === 'add' ? 'Add Item' : 'Update Item'}
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

InventoryForm.propTypes = {
  open: PropTypes.bool.isRequired,
  mode: PropTypes.string.isRequired,
  formData: PropTypes.object.isRequired,
  formErrors: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onInputChange: PropTypes.func.isRequired,
};

export default InventoryForm;